import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { Form } from 'src/shared/components/ui/forms/form'

import BusinessFormButtonsField from '../../components/business-form-buttons-field'
import BusinessFormDisclaimer from '../../components/business-form-disclaimer'
import BusinessFormTitle from '../../components/business-form-title'
import { useBusinessCreateContext } from '../../context/business-create-context'
import { useBusinessCreateStore } from '../../store/business-create-store'

const IsClosedSchema = z.object({
  isClosed: z.enum(['true', 'false'], { message: 'Business status is required' }),
})
type IsClosedSchemaType = z.infer<typeof IsClosedSchema>

export default function BusinessCreateIsClosedStep() {
  const { setFormData, formData } = useBusinessCreateStore()
  const { handleNext, setFooterConfig } = useBusinessCreateContext()

  const options = [
    {
      label: 'Past client to nurture',
      value: 'true',
    },
    {
      label: 'Active business',
      value: 'false',
    },
  ]

  const form = useForm<IsClosedSchemaType>({
    resolver: zodResolver(IsClosedSchema),
    defaultValues: {
      isClosed: typeof formData.isClosed === 'boolean' ? (formData.isClosed ? 'true' : 'false') : undefined,
    },
  })

  useEffect(() => {
    setFooterConfig(null)
  }, [handleNext, setFooterConfig])

  const onSubmit = (data: IsClosedSchemaType) => {
    const isClosed = data.isClosed === 'true'
    setFormData({
      ...formData,
      isClosed,
      closedAt: isClosed ? formData.closedAt : null,
    })
    handleNext()
  }

  const onIsClosedPress = () => {
    form.handleSubmit(onSubmit)()
  }

  return (
    <div className="flex size-full flex-col items-center justify-center gap-10">
      <BusinessFormTitle>{`Is this active business or a past client to nurture?`}</BusinessFormTitle>
      <Form {...form}>
        <form id="business-create-form" onSubmit={form.handleSubmit(onSubmit)} className="w-full">
          <BusinessFormButtonsField
            options={options}
            control={form.control}
            name="isClosed"
            onPress={onIsClosedPress}
          />
          <div className="mt-4 flex w-full items-center justify-center">
            <BusinessFormDisclaimer>This helps Lynk be sure of which workflow to kick off</BusinessFormDisclaimer>
          </div>
        </form>
      </Form>
    </div>
  )
}
